import { createContext } from '@/utils/contextUtils'

import { IAuthContext } from './types'

export const authContext = createContext<IAuthContext>(undefined)
